module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-font-72ef1f0c.svg";